import { MyRealtimeChannelDTO } from '../../types/realtime/MyRealtimeChannelDTO';

export const hasRealtimeChannel = (
  channels: MyRealtimeChannelDTO[] = [],
  code: string
): boolean =>
  channels.some(channel => channel.code === code);